module.exports = __webpack_public_path__ + "img/RedteaSIM_EN02.b8872444.jpg";